<template>
  <WsVersion
    label="每日點檢表公版版本列表"
    :localeMode="true"
    :id="$route.params.id"
    :modelName="modelName"
    :versionModelName="versionModelName"
    :fields="versionFields"
    :showFields="showFields"
  ></WsVersion>
</template>

<script>
import model from "@/models/checklist_conclusion_daily_template";
export default {
  data: () => ({
    modelName: model.modelName,
    versionModelName: model.versionModelName,
    versionFields: model.fields.last_version.fields,
    showFields: ["locales", "updated_admin", "updated_at"],
  }),
};
</script>

<style>
</style>